import { createContext, ReactNode } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import initialState, { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import reducer, { TAllServiceEngineerActions } from '@r1-frontend/service-engineer-visit/reducer/reducer';

export type TContextDispatch = ThunkDispatch<TInitialState, TAllServiceEngineerActions>

export type TContext = {
    state: TInitialState,
    dispatch: TContextDispatch,
    debugMode?: boolean,
}

export const Context = createContext<TContext>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
});

type TContextProviderProps = {
    children: ReactNode,
    debugMode?: boolean,
}

const ContextProvider = ({ children, debugMode }: TContextProviderProps): JSX.Element => {
    const [state, dispatch] = useThunkReducer<TInitialState, TAllServiceEngineerActions>(reducer, initialState);

    if (debugMode) {
        console.log(state);
    }

    return (
        <Context.Provider value={{ state, dispatch, debugMode }}>{children}</Context.Provider>
    );
};

export default ContextProvider;
